// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"OrderStatusMapWrapper-e8661d6bb263e46d"};